import { Component, Input, OnInit } from '@angular/core';
import { UserModel } from '../../models/base.models';


@Component({
  selector: 'app-users-group',
  templateUrl: './users-group.component.html',
  styleUrls: ['./users-group.component.css']
})
export class UsersGroupComponent implements OnInit {
  // @Input() size: 'sm' | 'lg' = 'lg';

  @Input() users: UserModel[] = []
  _width: string = '40px';
  constructor() { }

  @Input('size') set Size(value: 'sm' | 'lg' ) {
    switch (value) {
      case 'sm':
        this._width = '30px';
        break;

      default:
        this._width ='40px';
        break;
    }
  }

  ngOnInit() {
  }

}
